import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap5';

import routes from 'app/routes';
import Modal from 'components/new_ui/Modal/Modal';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext as useTemplatesContext } from 'components/Managers/Templates/Context';
import ModalChooseTemplate from './ModalChooseTemplate';

export default function ModalCreateMethod({ show, onClose }) {
  const [showChooseTemplate, setShowChooseTemplate] = useState(false);
  const [loading, setLoading] = useState(false);

  const { dispatch: dispatchTemplates, actions: actionsTemplates } = useTemplatesContext();
  const navigate = useNavigate();

  const closeChooseTemplate = useCallback(() => {
    setShowChooseTemplate(false);
  }, []);
  const openChooseTemplate = () => {
    onClose();
    setShowChooseTemplate(true);
  };

  const createNewTemplate = () => {
    setLoading(true);
    actionsTemplates.new(dispatchTemplates, null, (data) => {
      setLoading(false);
      onClose();
      navigate(
        routes.managers.templates.chooseTopics,
        {
          state: {
            template: data,
          },
        },
      );
    });
  };

  return (
    <>
      <Modal onHide={onClose} show={show} header="Create a new Coaching Program">
        <p>Would you like to create it from scratch or use another program as a template?</p>

        <footer className="text-center">
          <Button
            variant="outline-primary"
            className="btn-reverse"
            onClick={() => openChooseTemplate()}
          >
            Use Template
          </Button>

          <Button
            className="ms-0 ms-md-3 mt-3 mt-md-0"
            onClick={() => createNewTemplate()}
            disabled={loading}
          >
            {loading && <LoadingPlaceholder placement="inline" />}
            {' '}
            Create New
          </Button>
        </footer>
      </Modal>

      <ModalChooseTemplate
        show={showChooseTemplate}
        onClose={closeChooseTemplate}
        createNewTemplate={createNewTemplate}
      />
    </>
  );
}

ModalCreateMethod.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

ModalCreateMethod.defaultProps = {
  show: false,
  onClose: () => {},
};
